<script setup lang="ts">
import { ref } from "vue";
import { throttle } from "@zyzgroup/core-common";
import CSSAnimation from "./CSSAnimation.vue";

// for merge ce shadow-root styles
defineOptions({
  customOptions: { CSSAnimation },
  inheritAttrs: true
});

const props = withDefaults(
  defineProps<{
    isRefreshing?: boolean;
    isLoading?: boolean;
    isNoMore?: boolean;
  }>(),
  {
    isRefreshing: false, // 父组件正在响应：下拉刷新
    isLoading: false, // 父组件正在响应：上拉加载
    isNoMore: false // 没有更多了
  }
);

const emits = defineEmits<{
  (event: "refreshing"): void; // 顶部下拉刷新
  (event: "loading"): void; // 底部上拉加载
}>();

const el = ref();

// const scroll = throttle(() => {
const scroll = () => {
  const container = el.value;
  if (!container) {
    return;
  }
  const scrollTop = container.scrollTop;
  const scrollHeight = container.scrollHeight;
  const clientHeight = container.clientHeight;
  // 顶部下拉刷新
  if (scrollTop <= 0 && !props.isRefreshing && !props.isLoading) {
    emits("refreshing");
    return;
  }
  // 底部上拉加载
  if (props.isNoMore) {
    return;
  }
  if (
    scrollTop + clientHeight >= scrollHeight &&
    !props.isRefreshing &&
    !props.isLoading
  ) {
    emits("loading");
    return;
  }
};

defineExpose({});
</script>

<template>
  <div
    ref="el"
    class="list"
    @scroll="scroll"
  >
    <!-- 顶部下拉刷新 -->
    <div
      v-if="props.isRefreshing"
      class="list-refreshing"
    >
      <div class="list-loader"></div>
    </div>

    <!-- 真正内容 -->
    <slot></slot>

    <!-- 底部上拉加载 -->
    <div
      v-if="props.isLoading"
      class="list-loading"
    >
      <div class="list-loader"></div>
    </div>

    <!-- 没有更多了 -->
    <div
      v-if="props.isNoMore"
      class="list-loading"
    >
      没有更多了
    </div>
  </div>
</template>

<style scoped>
.list {
  position: relative;
  width: 100%;
  height: 100%;
  overflow-y: scroll;
}
.list-refreshing,
.list-loading {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: var(--yz-font-size-secondary, 14px);
  color: #cccccc;
  padding: 10px 0;
}
.list-loader {
  width: 20px;
  height: 20px;
  background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg%20viewBox%3D'0%200%20120%20120'%20xmlns%3D'http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg'%20xmlns%3Axlink%3D'http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink'%3E%3Cdefs%3E%3Cline%20id%3D'l'%20x1%3D'60'%20x2%3D'60'%20y1%3D'7'%20y2%3D'27'%20stroke%3D'%236c6c6c'%20stroke-width%3D'11'%20stroke-linecap%3D'round'%2F%3E%3C%2Fdefs%3E%3Cg%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.27'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.27'%20transform%3D'rotate(30%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.27'%20transform%3D'rotate(60%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.27'%20transform%3D'rotate(90%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.27'%20transform%3D'rotate(120%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.27'%20transform%3D'rotate(150%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.37'%20transform%3D'rotate(180%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.46'%20transform%3D'rotate(210%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.56'%20transform%3D'rotate(240%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.66'%20transform%3D'rotate(270%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.75'%20transform%3D'rotate(300%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.85'%20transform%3D'rotate(330%2060%2C60)'%2F%3E%3C%2Fg%3E%3C%2Fsvg%3E");
  background-position: 50%;
  background-size: 100%;
  background-repeat: no-repeat;
  animation: loader-spin 1s steps(12, end) infinite;
}
@keyframes loader-spin {
  100% {
    transform: rotate(360deg);
  }
}
</style>
